var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"first-step-page-container"},[_c('div',{staticClass:"content-wrapper"},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),_c('notifications')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }